import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { iconHeaderLogo, iconHelp, iconProfile } from '~utils/svgIcons';
import './style.scss';
// import SnowHat from './SnowHat.svg';

function Header({ children, disabled }) {
    return (
        <header className={`header${disabled ? ' disabled' : ''}`}>
            <a
                href="/"
                className="header__logo"
                onClick={() => window.ym && window.ym(73097359, 'hit', window.location.href)}
            >
                {iconHeaderLogo}
                <span>TrackTrack</span>
            </a>
            <div className="header__wrap">
                <div className="header__navigation">{children}</div>
                <div className="header__user-auth">
                    {window.location.pathname.search('/laws') !== -1 && (
                        <div className="header__user-info">
                            <Link
                                to="/faq"
                                onClick={() => window.ym && window.ym(73097359, 'hit', window.location.href)}
                            >
                                <div className="header__icon">{iconHelp}</div>
                                <span className="header__acessability-description">Информация</span>
                            </Link>
                        </div>
                    )}
                    <div className="header__user-auth-inner">
                        <Link
                            to="/user/settings"
                            onClick={() => window.ym && window.ym(73097359, 'hit', window.location.href)}
                        >
                            {/* <img className="snow-hat" alt="" src={SnowHat} /> */}
                            <div className="header__icon">{iconProfile}</div>
                            <span className="header__acessability-description">Личный кабинет</span>
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    );
}

Header.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
};

export default Header;
export { Header };



// WEBPACK FOOTER //
// ./src/components/header/index.js